import { Box, Typography, Container, Link } from "@mui/material";
import React from "react";
import logoFooter from "../assets/img/logo-footer.png";

const FooterSection = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <Box
      component="footer"
      sx={{
        bgcolor: "#1a1a1a",
        color: "#ffffff",
        pt: 6,
        pb: 4,
        width: "100%",
      }}
    >
      <Container maxWidth="lg">
        {/* Main Footer Content */}
        <Box sx={{ 
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          justifyContent: "space-between",
          gap: { xs: 4, md: 6 },
          mb: 5
        }}>
          
          {/* Left Side - Logo & Description */}
          <Box sx={{ flex: "0 0 auto", maxWidth: { xs: "100%", md: "400px" } }}>
            <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
              <Box
                component="img"
                src={logoFooter}
                alt="Alfa 2020"
                sx={{ 
                  width: 48, 
                  height: 48, 
                  objectFit: "cover",
                  mr: 1.5
                }}
              />
              <Typography sx={{ 
                fontSize: 20, 
                fontWeight: 600,
                color: "#ffffff"
              }}>
                AlfaTeam
              </Typography>
            </Box>
            
            <Typography sx={{
              color: "#b0b0b0",
              fontSize: 14,
              lineHeight: 1.7,
              mb: 3
            }}>
              Empowering businesses with reliable technical support and network solutions.
            </Typography>
          </Box>

          {/* Right Side - Info Columns */}
          <Box sx={{ 
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            gap: { xs: 3, sm: 6, md: 8 },
            flex: "1 1 auto"
          }}>
            
            {/* Contact Column */}
            <Box sx={{ flex: "1 1 0" }}>
              <Typography sx={{ 
                fontSize: 12,
                fontWeight: 600,
                color: "#888",
                textTransform: "uppercase",
                letterSpacing: "0.1em",
                mb: 2
              }}>
                Contact
              </Typography>
              
              <Box sx={{ display: "flex", flexDirection: "column", gap: 1.2 }}>
                <Typography sx={{ fontSize: 14, color: "#b0b0b0", lineHeight: 1.6 }}>
                  Veľká Okružná 17<br />
                  010 01 Žilina<br />
                  Slovakia
                </Typography>
                
                <Link
                  href="mailto:office@alfagroup-24.com"
                  sx={{
                    fontSize: 14,
                    color: "#b0b0b0",
                    textDecoration: "none",
                    transition: "color 0.2s",
                    "&:hover": { color: "#ffffff" }
                  }}
                >
                  office@alfagroup-24.com
                </Link>
                
                <Link
                  href="tel:+421952171518"
                  sx={{
                    fontSize: 14,
                    color: "#b0b0b0",
                    textDecoration: "none",
                    transition: "color 0.2s",
                    "&:hover": { color: "#ffffff" }
                  }}
                >
                  +421 952 171 518
                </Link>
              </Box>
            </Box>

            {/* Company Column */}
            <Box sx={{ flex: "1 1 0" }}>
              <Typography sx={{ 
                fontSize: 12,
                fontWeight: 600,
                color: "#888",
                textTransform: "uppercase",
                letterSpacing: "0.1em",
                mb: 2
              }}>
                Company
              </Typography>
              
              <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                <Typography sx={{ fontSize: 14, color: "#b0b0b0" }}>
                  Alfa 2020 s.r.o.
                </Typography>
                <Typography sx={{ fontSize: 13, color: "#888" }}>
                  IČO: 55 823 521
                </Typography>
                <Typography sx={{ fontSize: 13, color: "#888" }}>
                  Reg: 83529/L
                </Typography>
              </Box>
            </Box>
            
          </Box>
        </Box>

        {/* Divider */}
        <Box sx={{ 
          height: "1px", 
          bgcolor: "#333", 
          mb: 3 
        }} />

        {/* Bottom Bar */}
        <Box sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          justifyContent: "space-between",
          alignItems: { xs: "flex-start", sm: "center" },
          gap: 2
        }}>
          
          <Typography sx={{ 
            fontSize: 13, 
            color: "#888"
          }}>
            © {currentYear} Alfa 2020 s.r.o. All rights reserved.
          </Typography>

          <Box sx={{ 
            display: "flex", 
            gap: 3,
            flexWrap: "wrap"
          }}>
            <Link
              href="/privacy-policy"
              sx={{
                fontSize: 13,
                color: "#888",
                textDecoration: "none",
                transition: "color 0.2s",
                "&:hover": { color: "#ffffff" }
              }}
            >
              Privacy Policy
            </Link>
            
            <Link
              href="/terms-conditions"
              sx={{
                fontSize: 13,
                color: "#888",
                textDecoration: "none",
                transition: "color 0.2s",
                "&:hover": { color: "#ffffff" }
              }}
            >
              Terms & Conditions
            </Link>
            
            <Link
              href="/refund-policy"
              sx={{
                fontSize: 13,
                color: "#888",
                textDecoration: "none",
                transition: "color 0.2s",
                "&:hover": { color: "#ffffff" }
              }}
            >
              Refund Policy
            </Link>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default FooterSection;